









import PageTitle from '@/components/common/PageTitle.vue';
import AdminIframe from '@/components/iframe/AdminIframe.vue';

export default {
  components: { PageTitle, AdminIframe },
  data: function() {
    return {
      remoteSrc: '',
    };
  },
  methods: {
    setRemoteSrc() {
      const query = this.$route.query;
      const queryObject = { ...query, serviceType: 'PREMIUM' };
      const queryString = new URLSearchParams(queryObject).toString();

      this.remoteSrc =
        process.env.VUE_APP_ADMIN_REMOTE_URL + '/authorityGroup/list?' + queryString;
    },
  },
  created: function() {
    this.setRemoteSrc();
  },
};
